import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getUserDiscountData } from '@olxbr/mojo-jojo/selectors/discount';
import { unsetMyadsMobileDiscount } from '@olxbr/mojo-jojo/actions/discount';
import { PointOfSaleContext } from '@olxbr/mojo-jojo/contexts';

import { useCookies } from 'react-cookie';

import { sendScroll } from '../../services/tracking';
import withVisibilityToggle from '../../../core/enhancements/withVisibilityToggle';
import BundleHVModal from '../BundleHVModal';

import ProductPicker from './product-picker/ProductPicker';
import DiscountModal from './product-discount-modal/DiscountModal';
import ProductsList from '../product/ProductsList';
import Header from '../product/HeaderContainer';
import Navbar from '../navbar/NavbarContainer';
import Banner from './Banner';
import BannerWithTimer from './banner/BannerWithTimer';

import './Products.css';
import MyAdsLink from '../MyAdsLinkContainer';
import Benefits from './product-benefits/BenefitsContainer';

const Wrapper = styled.section`
  width: 100%;
  display: block;
  margin: 0 auto;
  background-color: '#f9f9f9';
  @media (min-width: 1000px) {
    width: ${props => (props.products > 3 ? '90%' : '970px')};
    max-width: 1294px;
  }
`;

const VisibleNavbar = withVisibilityToggle(Navbar);
const VisibleHeader = withVisibilityToggle(Header);
const DiscountBanner = withVisibilityToggle(Banner);
const BannerWithTimerContainer = withVisibilityToggle(BannerWithTimer);

const StepButtonWrapper = styled.div`
  text-align: center;
  margin: 32px 0px;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;

const Text = styled.span`
  font-size: 16px;
  line-height: 1.5;
  color: #4a4a4a;
`;

const DiamondMonthlyObservationText = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
  padding: 8px 14px;
  color: #999999;
  text-align: center;
  margin-bottom: -25px;
  ::before{
    content: "*O novo Destaque Diamante mensal só está disponível no nosso site e em alguns pontos de venda.";
  }
`;

function getScrollPercent() {
  const element = document.documentElement;
  const { body } = document;
  const SCROLL_TOP = 'scrollTop';
  const SCROLL_HEIGHT = 'scrollHeight';

  return (
    ((element[SCROLL_TOP] || body[SCROLL_TOP]) /
      ((element[SCROLL_HEIGHT] || body[SCROLL_HEIGHT]) -
        element.clientHeight)) *
    100
  );
}

const eventCache = { 25: null, 50: null, 100: null };

const handleScroll = (pointofSale, funnelId, categoryId, region, zipcode) => {
  const scrollPosition = Math.round(getScrollPercent());

  if (scrollPosition >= 25 && scrollPosition < 50 && !eventCache[25]) {
    eventCache[25] = 'sent';

    sendScroll(pointofSale, 25, funnelId, categoryId, region, zipcode);
  }

  if (scrollPosition >= 50 && scrollPosition < 100 && !eventCache[50]) {
    eventCache[50] = 'sent';

    sendScroll(pointofSale, 50, funnelId, categoryId, region, zipcode);
  }

  if (scrollPosition === 100 && !eventCache[100]) {
    eventCache[100] = 'sent';

    sendScroll(pointofSale, 100, funnelId, categoryId, region, zipcode);
  }
};

// Remover quando o banner de desconto não for mais usado ou quando os descontos não forem mais passados somente nos produtos
const hasDiscount = product => product.discount && product.discountId;

const getDiscountFrom = (productsData) => {
  const products = productsData.highlights;

  if (products) {
    const productWithDiscount = products.find(hasDiscount);
    return productWithDiscount ? productWithDiscount.discount : null;
  }

  return null;
};

const Products = ({userDiscountData, unsetUserDiscount}) => (
  <PointOfSaleContext>
    {({
      contentData, productsData, posData, limitsData, adData, extrasData,
    }) => {
      /* eslint-disable */
      const [isDiscountModalVisible, setDiscountModalVisibility] = useState(false);
      const [discountModalAlreadyShown, setDiscountModalShown] = useState(false);
      const [cookies] = useCookies(['payg-bundle-hv']);
      /* eslint-enable */

      const handleDiscountModalClose = () => {
        setDiscountModalShown(true);
        setDiscountModalVisibility(false);
      };
      const discount = getDiscountFrom(productsData);

      const hvBundleCookie = cookies['payg-bundle-hv'] || '';
      const hasBundleHvProduct = productsData.highlights && productsData.highlights.find(product => product.type.includes('BUNDLE_HV'));
      const hvModalAlreadyShown = hasBundleHvProduct ? hvBundleCookie.includes(`${posData.parentName}-payg-bundle-hv`) : true;

      const mouseOutEventListener = (event) => {
        if (event.toElement == null && event.relatedTarget == null) {
          setDiscountModalVisibility(hvModalAlreadyShown);
        }
      };
      const handleDiscountModalOpen = () => {
        setDiscountModalVisibility(hvModalAlreadyShown);
      };
      //eslint-disable-next-line
      useEffect(() => {
        window.addEventListener(
          'scroll',
          () => handleScroll(posData.parentName, posData.funnelId, adData.categoryId, adData.region, adData.zipcode),
          true,
        );

        window.addEventListener(
          'mouseout',
          mouseOutEventListener,
          true,
        );

        return () => {
          window.removeEventListener('scroll', handleScroll);
          window.removeEventListener('mouseout', mouseOutEventListener);
        };
      }, []);

      const shouldShowDiscountModal = () => discount && !discountModalAlreadyShown && isDiscountModalVisible && posData.parentName === 'free-insertion';

      const hasDiamondMonthlyProduct = Array.isArray(productsData.highlights) && productsData.highlights.find(product => product.type === 'PACKAGE_DIAMOND_MONTHLY');
      const isAcceptToMoveWithoutHighlight = posData && (posData.name.includes('free-insertion') || posData.name.includes('free-edition'));

      let newBenefits = [];

      if (contentData.benefits) {
        newBenefits = [
          ...contentData.benefits,
          {
            id: 'superShowcase',
            image: 'https://static.olx.com.br/osp/ilustra-supervitrine.png',
            text: 'A Super Vitrine é um novo visual diferenciado para seus anúncios. \n\n -**Tamanho superior** aos outros anúncios \n\n -**Maior número de fotos** visíveis na busca de anúncios. \n\n Incluído no destaque **Diamante.**',
            title: 'Super Vitrine *NOVO*',
          },
        ];

        newBenefits[1] = {
          ...newBenefits[1],
          title: `${newBenefits[1].title} **super vitrine**`,
        };
      }

      return (
        <Fragment>
          <VisibleNavbar showIf={posData.currentStep === 'highlights-v2'} onMouseOver={handleDiscountModalOpen} />
          <DiscountBanner
            showIf={discount && !userDiscountData}
            content={contentData}
            discount={discount}
            marginBottom={discount && posData.name === 'cars-subscription' ? '50px' : '0px'} // TODO retirar essa prop depois que o desconto do semipro sair do ar
          />
          <BundleHVModal posName={posData.name} hasBundleHvProduct={hasBundleHvProduct} />
          <VisibleHeader
            purchased={posData.alreadyBoughtProduct}
            content={contentData}
            limits={limitsData}
            type={posData.parentName}
            adName={adData.name}
            showIf={posData.currentStep === 'highlights-v2'}
            ad={adData}
          />
          <BannerWithTimerContainer 
            showIf={discount && userDiscountData}
            userDiscount={userDiscountData}
            unsetUserDiscount={unsetUserDiscount}
            />
          <Wrapper
            products={
              productsData.highlights ? productsData.highlights.length : 0
            }
          >
            {shouldShowDiscountModal() && <DiscountModal funnelId={posData.funnelId} discountAmount={discount} onClose={handleDiscountModalClose} discountMessage={contentData.discount.message} />}
            <section className="box-packages visible-only-on-large block-on-large">
              <ProductsList
                posDiscount={extrasData.discount}
                products={productsData.highlights}
                posName={posData.parentName}
                categoryBalance={limitsData.balance.value}
              />
              {hasDiamondMonthlyProduct && <DiamondMonthlyObservationText />}
            </section>
            <section className="mobile-box-packages hidden-only-on-large">
              <ProductPicker
                products={productsData.highlights}
                type={posData.type}
                isFee={posData.limitExceeded}
                categoryBalance={limitsData.balance.value}
              />
              {hasDiamondMonthlyProduct && <DiamondMonthlyObservationText />}
            </section>

            <StepButtonWrapper visible={isAcceptToMoveWithoutHighlight}>
              <MyAdsLink onMouseOver={handleDiscountModalOpen}>Clique aqui</MyAdsLink>{' '}
              <Text>para seguir sem destaque</Text>
            </StepButtonWrapper>
          </Wrapper>
          <Benefits
            id="benefits"
            benefits={contentData.benefits}
            posName={posData.parentName}
          />
          {/* <QuestionsBox questions={contentData.questions} /> */}
        </Fragment>
      );
    }}
  </PointOfSaleContext>
);

const mapStateToProps = (state) => ({
  userDiscountData: getUserDiscountData(state),
});

export default connect(mapStateToProps, { unsetUserDiscount: unsetMyadsMobileDiscount })(Products);
